import { render, staticRenderFns } from "./BarButton.vue?vue&type=template&id=219c33da&scoped=true"
import script from "./BarButton.vue?vue&type=script&lang=js"
export * from "./BarButton.vue?vue&type=script&lang=js"
import style0 from "./BarButton.vue?vue&type=style&index=0&id=219c33da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c33da",
  null
  
)

export default component.exports